import {BarPattern, Segment} from 'common/charts/visualization/bar-viz/types';

export const barVizData: Segment[] = [
  {
    segmentName: `Event`,
    label: `Viewed Report`,
    children: [
      {
        segmentName: `Country`,
        label: `Canada`,
        valueLabel: `123`,
        children: [
          {
            segmentName: `City`,
            label: `Vancouver`,
            bars: [
              {segments: [{value: 193, label: `193`}]},
              {segments: [{value: 123, label: `123`, pattern: BarPattern.Striped}]},
            ],
          },
          {
            segmentName: `City`,
            label: `Toronto`,
            bars: [
              {segments: [{value: 103, label: `103`}]},
              {segments: [{value: 13, label: `13`, pattern: BarPattern.Striped}]},
            ],
          },
        ],
      },
      {
        segmentName: `Country`,
        label: `United States`,
        valueLabel: `12`,
        children: [
          {
            segmentName: `City`,
            label: `San Francisco`,
            bars: [
              {segments: [{value: 93, label: `93`}]},
              {segments: [{value: 33, label: `33`, pattern: BarPattern.Striped}]},
            ],
          },
          {
            segmentName: `City`,
            label: `New York`,
            bars: [
              {segments: [{value: 193, label: `193`}]},
              {segments: [{value: 123, label: `123`, pattern: BarPattern.Striped}]},
            ],
          },
        ],
      },
    ],
  },
  {
    segmentName: `Event`,
    label: `Not Viewed Report`,
    children: [
      {
        segmentName: `Country`,
        label: `Canada`,
        valueLabel: `123`,
        children: [
          {
            segmentName: `City`,
            label: `Vancouver`,
            bars: [
              {segments: [{value: 193, label: `193`}]},
              {segments: [{value: 123, label: `123`, pattern: BarPattern.Striped}]},
            ],
          },
          {
            segmentName: `City`,
            label: `Toronto`,
            bars: [
              {segments: [{value: 103, label: `103`}]},
              {segments: [{value: 13, label: `13`, pattern: BarPattern.Striped}]},
            ],
          },
        ],
      },
      {
        segmentName: `Country`,
        label: `United States`,
        valueLabel: `12`,
        children: [
          {
            segmentName: `City`,
            label: `San Francisco`,
            bars: [
              {segments: [{value: -93, label: `-93`}]},
              {segments: [{value: -33, label: `-33`, pattern: BarPattern.Striped}]},
            ],
          },
          {
            segmentName: `City`,
            label: `New York`,
            bars: [
              {segments: [{value: -193, label: `-193`}]},
              {segments: [{value: -123, label: `-123`, pattern: BarPattern.Striped}]},
            ],
          },
        ],
      },
    ],
  },
];

export const stackedBarVizData: Segment[] = [
  {
    segmentName: `Event`,
    label: `Viewed Report`,
    children: [
      {
        segmentName: `Country`,
        label: `Canada`,
        bars: [
          {
            label: `12232`,
            segments: [
              {value: 193, label: `193`},
              {value: 123, label: `123`},
            ],
          },
          {
            label: `123`,
            segments: [
              {value: 123, label: `123`, pattern: BarPattern.Striped},
              {value: 123, label: `123`, pattern: BarPattern.Striped},
              {value: 123, label: `123`, pattern: BarPattern.Striped},
            ],
          },
        ],
      },
      {
        segmentName: `Country`,
        label: `United States`,
        bars: [
          {
            label: `12`,
            segments: [
              {value: 193, label: `193`},
              {value: 20, label: `20`},
              {value: 50, label: `50`},
            ],
          },
          {
            label: `12`,
            segments: [
              {value: 200, label: `200`, pattern: BarPattern.Striped},
              {value: 128, label: `128`, pattern: BarPattern.Striped},
            ],
          },
        ],
      },
    ],
  },
  {
    segmentName: `Event`,
    label: `Not Viewed Report`,
    children: [
      {
        segmentName: `Country`,
        label: `Poland`,
        bars: [
          {
            label: `13`,
            segments: [
              {value: 193, label: `222`},
              {value: 123, label: `12`},
              {value: 54, label: `54`},
            ],
          },
          {
            label: `23`,
            segments: [
              {value: 43, label: `43`, pattern: BarPattern.Striped},
              {value: 122, label: `222`, pattern: BarPattern.Striped},
            ],
          },
        ],
      },
      {
        segmentName: `Country`,
        label: `United States`,
        valueLabel: `12`,
        bars: [
          {
            label: `123`,
            segments: [
              {value: 193, label: `193`},
              {value: 123, label: `20`},
              {value: 123, label: `50`},
            ],
          },
          {
            label: `12`,
            segments: [
              {value: 123, label: `200`, pattern: BarPattern.Striped},
              {value: 123, label: `128`, pattern: BarPattern.Striped},
            ],
          },
        ],
      },
    ],
  },
];
